import { t } from '../../hooks/useT';

export type AdminTabId = 'stats' | 'users' | 'puzzles';

interface AdminTabsProps {
  active: AdminTabId;
  onChange: (tab: AdminTabId) => void;
}

const TABS: { id: AdminTabId; labelKey: string }[] = [
  { id: 'stats', labelKey: 'admin.tab.stats' },
  { id: 'users', labelKey: 'admin.tab.users' },
  { id: 'puzzles', labelKey: 'admin.tab.puzzles' },
];

export function AdminTabs({ active, onChange }: AdminTabsProps) {
  return (
    <nav className="admin-tabs" role="tablist" aria-label={t('admin.title')}>
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={`admin-tab${active === tab.id ? ' active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </nav>
  );
}
